/**
 * ConfirmSubmit
 */

import { useState, useEffect } from 'react';
import { isNil } from 'lodash-es';
import { useApi2fetch } from 'containers/Api2/index.js';
import { parseISO, format } from 'utils/date-fns/index.js';
import { dateString } from 'utils/timeFormat.js';

const SEARCH_FIELDS = ['firstName', 'middleName', 'lastName', 'birthDate'];

function mapTestValue(o, key) {
  const val = o[key];
  if (isNil(val)) {
    return val;
  }
  return key === 'birthDate' ? dateString(val) : val.toLowerCase();
}

function isSame(o1, o2) {
  return SEARCH_FIELDS.every((key) => mapTestValue(o1, key) === mapTestValue(o2, key));
}

function mapStringValue(o, key) {
  const val = o[key];
  return (key === 'birthDate' && val) ? `(${format(parseISO(val), 'dd-MM-yyyy')})` : val;
}

function useMatchusers(users, roleName) {
  const [withIds, setIds] = useState();
  const api2fetch = useApi2fetch();
  useEffect(() => {
    api2fetch({
      method: 'POST',
      url: `sa/users/${roleName}/searchlist`,
      version: 2,
      body: { users },
      noParse: true,
    })
      .then(setIds);
  }, [users, roleName]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!withIds) {
    return { working: true };
  }
  const unmatched = [];
  const matched = [];
  users.forEach((row) => {
    const idRow = withIds?.users?.find((o) => isSame(row, o));
    const searchString = SEARCH_FIELDS.map((key) => mapStringValue(row, key)).filter(Boolean).join(' ');
    if (idRow?.id) {
      matched.push({ ...row, searchString, id: idRow.id });
    } else {
      unmatched.push({ ...row, searchString });
    }
  });
  return { matched, unmatched };
}

export default useMatchusers;
